export const ERROR_VALIDATING_TOKEN = 'ERROR_VALIDATING_TOKEN';

const errorCodes = new Map([
	['ERROR_TIMEOUT', { translationKey: 'error.timeout', generalError: true, formField: [] }],
	[
		'WRONG_RESPONSE',
		{
			translationKey: 'error.wrong.response',
			generalError: true,
			formField: [],
		},
	],
	['AN_ERROR_OCCURED', { translationKey: 'error.occured', generalError: true, formField: [] }],
	[
		'ERROR_INVALID_OMANTEL_NUMBER',
		{
			translationKey: 'error.invalid.omantel.number',
			generalError: false,
			formField: ['login'],
		},
	],
	['ERROR_SENDING_OTP', { translationKey: 'error.sending.otp', generalError: true, formField: [] }],
	[
		'PROFILE_NOT_FOUND_BY_EMAIL',
		{
			translationKey: 'error.profile.not.found.by.email',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_GETTING_USER_DATA',
		{
			translationKey: 'error.getting.user.data',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_INVALID_REQUEST',
		{
			translationKey: 'error.invalid.request',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_USER_LOGIN',
		{
			translationKey: 'error.invalid.user.login',
			generalError: true,
			formField: [],
		},
	],
	[
		'UNVERIFIED_SESSION',
		{
			translationKey: 'error.unverified.session',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_OTP_PROVIDED',
		{
			translationKey: 'error.invalid.otp.provider',
			generalError: false,
			formField: ['otp'],
		},
	],
	[
		'ERROR_VALIDATING_OTP',
		{
			translationKey: 'error.validating.otp',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_CREDENTIALS',
		{
			translationKey: 'error.invalid.credentials',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'PASSWORD_DOES_NOT_MATCH',
		{
			translationKey: 'error.password.does.not.match',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'INVALID_MSISDN_FORMAT',
		{
			translationKey: 'error.invalid.format',
			generalError: true,
			formField: [],
		},
	],
	[
		'PASSWORD_CAN_NOT_BE_EMPTY',
		{
			translationKey: 'error.password.can.not.be.empty',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'PASSWORD_TOO_SHORT',
		{
			translationKey: 'error.password.too.short',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'PASSWORD_TOO_LONG',
		{
			translationKey: 'error.password.too.long',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'PASSWORD_CONTAINS_INVALID_CHARACTERS',
		{
			translationKey: 'error.password.contains.invalid.characters',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'PASSWORD_TOO_WEAK',
		{
			translationKey: 'error.password.too.week',
			generalError: false,
			formField: ['password'],
		},
	],
	[
		'INVALID_EMAIL_FORMAT',
		{
			translationKey: 'error.invalid.email.format',
			generalError: false,
			formField: ['email'],
		},
	],
	[
		'ERROR_QUERYING_USER_REPOSITORY',
		{
			translationKey: 'error.querying.user.repository',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_EMAIL_IS_ALREADY_USED',
		{
			translationKey: 'error.email.is.already.used',
			generalError: false,
			formField: ['email'],
		},
	],
	[
		'ERROR_QUERYING_DATABASE',
		{
			translationKey: 'error.querying.database',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_COMMUNICATING_WITH_BUS',
		{
			translationKey: 'error.communicating.with.bus',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_TOKEN_PROVIDED',
		{
			translationKey: 'error.invalid.token.provided',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_VALIDATING_TOKEN',
		{
			translationKey: 'error.validating.token',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_GETTING_LTPA_TOKEN',
		{
			translationKey: 'error.getting.ltpa.token',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_INVALID_LTPA_TOKEN',
		{
			translationKey: 'error.invalid.ltpa.token',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_GETTING_DATA_FROM_BUS',
		{
			translationKey: 'error.getting.data.from.bus',
			generalError: true,
			formField: [],
		},
	],
	[
		'ACTIVE_TOKEN_DOESNT_EXISTS',
		{
			translationKey: 'error.active.token.doesnt.exists',
			generalError: true,
			formField: [],
		},
	],
	[
		'ACCOUNT_NOT_FOUND',
		{
			translationKey: 'error.account.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'NOT_AUTHORIZED_FOR_GET_PRODUCTS',
		{
			translationKey: 'error.not.authorized.for.get.products',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_NO_VALID_ACCOUNT_FOUND',
		{
			translationKey: 'error.no.valid.account.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_RETRIEVING_BILL_FROM_BUS',
		{
			translationKey: 'error.retrieving.bill.from.bus',
			generalError: true,
			formField: [],
		},
	],
	[
		'UM_DATA_PARSE_RESULT_EXCEPTION',
		{
			translationKey: 'error.data.parse.result.exception',
			generalError: true,
			formField: [],
		},
	],
	[
		'UM_GET_CURRENT_USER_DATA_EXCEPTION',
		{
			translationKey: 'error.um.get.current.user.data.exception',
			generalError: true,
			formField: [],
		},
	],
	[
		'COULD_NOT_GENERATE_PHOTO_RESPONSE',
		{
			translationKey: 'error.could.not.generate.photo.response',
			generalError: true,
			formField: [],
		},
	],
	[
		'AUTHENTICATION_CODE_NOT_FOUND',
		{
			translationKey: 'error.authentication.code.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'REQUEST_TOP_UP_INVALID_ACTION_TYPE',
		{
			translationKey: 'error.request.topup.invalid.action.type',
			generalError: true,
			formField: [],
		},
	],
	[
		'REQUEST_ERROR_CREATING_DEVICE',
		{
			translationKey: 'error.request.creating.device',
			generalError: true,
			formField: [],
		},
	],
	[
		'REQUEST_DEVICE_OPERATION_FAILED',
		{
			translationKey: 'error.request.device.operation.failed',
			generalError: true,
			formField: [],
		},
	],
	[
		'CORP_USER_NOT_FOUND',
		{
			translationKey: 'error.request.corp.user.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'BILL_DATA_NOT_FOUND',
		{
			translationKey: 'error.request.bill.data.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_ACCOUNT_OR_INSUFFICIENT_RIGHTS',
		{
			translationKey: 'error.invalid.account.or.insufficient.rights',
			generalError: false,
			formField: [],
		},
	],
	[
		'INVALID_DEPARTMENT_OR_INSUFFICIENT_RIGHTS',
		{
			translationKey: 'error.invalid.department.or.insufficient.rights',
			generalError: false,
			formField: [],
		},
	],
	[
		'USER_ALREADY_EXISTS',
		{
			translationKey: 'error.user.exists',
			generalError: false,
			formField: [],
		},
	],
	[
		'DEPARTMENT_NOT_FOUND',
		{
			translationKey: 'error.department.not.found',
			generalError: false,
			formField: [],
		},
	],
	[
		'UNEXPECTED_EXCEPTION',
		{
			translationKey: 'error.unexpected.exception',
			generalError: false,
			formField: [],
		},
	],
	[
		'NO_FILE_DATA_FOUND',
		{
			translationKey: 'error.no.file.data',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_FILE_SIZE',
		{
			translationKey: 'error.invalid.file.size',
			generalError: true,
			formField: [],
		},
	],
	[
		'COMPANY_REGISTRATION_NUMBER_IS_ALREADY_REGISTERED',
		{
			translationKey: 'error.company.already.registered',
			generalError: true,
			formField: [],
		},
	],
	[
		'LANGUAGE_NOT_FOUND',
		{
			translationKey: 'error.language.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_SENDING_EMAIL_FAILED',
		{
			translationKey: 'error.sending.email',
			generalError: true,
			formField: [],
		},
	],
	[
		'INVALID_USERNAME_LENGTH',
		{
			translationKey: 'error.invalid.username.length',
			generalError: true,
			formField: [],
		},
	],
	[
		'UM_GET_USER_DATA_EXCEPTION',
		{
			translationKey: 'error.get.user.data',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_INVALID_FILE_EXTENSION',
		{
			translationKey: 'error.invalid.file.extension',
			generalError: true,
			formField: [],
		},
	],
	[
		'INSUFFICIENT_RIGHTS',
		{
			translationKey: 'error.insufficient.rights',
			generalError: true,
			formField: [],
		},
	],
	[
		'NUMBER_NOT_FOUND',
		{
			translationKey: 'error.number.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_REQUESTING_WEB_SERVICE',
		{
			translationKey: 'error.requesting.web.service',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_READING_MAIN_CONFIG',
		{
			translationKey: 'error.reading.main.config',
			generalError: true,
			formField: [],
		},
	],
	[
		'CR_NUMBER_NOT_FOUND',
		{
			translationKey: 'error.cr.number.not.found',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_EXECUTING_ACTION',
		{
			translationKey: 'error.executing.action',
			generalError: true,
			formField: [],
		},
	],
	[
		'ERROR_RETRIEVING_USER_DATA',
		{
			translationKey: 'error.retrieving.user.data',
			generalError: true,
			formField: [],
		},
	],
	[
		'MAXIMUM_ADMINS_LIMIT_EXCEEDED',
		{
			translationKey: 'error.maximum.admins.limit.exceeded',
			generalError: true,
			formField: [],
		},
	],
]);
export default errorCodes;
